'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import type { TrackingContext } from '@mentimeter/http-clients';
import { UserFeaturesTypeEnum } from '@mentimeter/http-clients';
import type { UpgradeButtonTrackingPlacement } from '@mentimeter/paywalls';
import type { UserT } from '@mentimeter/user';
import { StarSolidIcon } from '@mentimeter/ragnar-visuals';
import { trackUser } from '@api/tracking/client';
import {
  RequestUpgradeModal,
  RequestUpgradeButton,
} from '../lib/request-upgrade';
import { useFeatureAccess } from '../lib/hooks/use-feature-access';
import { UpgradeButton } from './UpgradeButton';

export const CollaborationUpgradeButton = ({
  size = 'default',
  trackingContext,
  trackingPlacement,
  user,
  isEducational,
}: {
  size?: 'default' | 'compact';
  user: UserT | null;
  trackingContext: TrackingContext | undefined;
  trackingPlacement: UpgradeButtonTrackingPlacement;
  isEducational: boolean;
}) => {
  const t = useTranslations('purchasing.collaboration.upgrade_button');
  const accessLevel = useFeatureAccess(UserFeaturesTypeEnum.PRO);

  if (!user || accessLevel === 'has-access') return null;

  if (accessLevel === 'not-in-role') {
    return (
      <RequestUpgradeModal
        trackingContext={trackingContext}
        trackingPlacement={trackingPlacement}
        description={t('tooltip_description')}
        title={t('tooltip_title')}
      >
        <RequestUpgradeButton
          size={size}
          variant="primary"
          iconLeading={StarSolidIcon}
        />
      </RequestUpgradeModal>
    );
  } else {
    return (
      <UpgradeButton
        isEducational={isEducational}
        size={size}
        text={t('button_text')}
        variant="primary"
        onClick={() => {
          trackUser({
            event: 'Plans from Invite view - collaboration',
          });
        }}
      />
    );
  }
};
